import { useEffect } from "react";
import aiDevelopmentService from "../../services/aiDevelopmentService";
import { lastEventSequence, mergeEvents } from "./aiDevelopmentViewModel";

export const canPollEvents=()=>typeof document==="undefined"||document.visibilityState!=="hidden";

export default function useIncrementalAiEvents(storyId,events,setData,delay=5000){
  useEffect(()=>{let cancelled=false;let timer;
    const poll=async()=>{if(cancelled)return;if(canPollEvents()){try{const incoming=await aiDevelopmentService.events(storyId,lastEventSequence(events));if(!cancelled&&incoming?.length)setData(prev=>({...prev,events:mergeEvents(prev.events,incoming)}));}catch{/* transient polling errors remain non-blocking */}}
      if(!cancelled)timer=setTimeout(poll,delay);};
    timer=setTimeout(poll,delay);return()=>{cancelled=true;clearTimeout(timer);};
  },[storyId,events,setData,delay]);
}
